__turbopack_context__.v({
  "body": "P_6fQq_body",
  "copyBlock": "P_6fQq_copyBlock",
  "description": "P_6fQq_description",
  "modalButton": "P_6fQq_modalButton",
  "modalRoot": "P_6fQq_modalRoot",
  "title": "P_6fQq_title",
});
